<template>
  <div class="">
    <sidebar-menu
      :menu="menu"
      width="16vw"
      :collapsed="collapsed"
      :hideToggle="true"
      :theme="selectedTheme"
      :show-one-child="true"
      :showChild="false"
      :relative="true"
      @item-click="onItemClick">

      <!-- <template slot="header">
        <div class="row  pl-2 pt-2 headerElementStyle">
          <div class="col-9">
            <h1 class="text-customcolor">{{sideBarTitle}}</h1>
          </div>
          <div class="col-3">
            <base-button
              size="sm"
              type="light"
              class="btn-customgray"
              icon="ni ni-curved-next"
              v-on:click="openModalClicked"
            >
            </base-button>
          </div>
        </div>

      </template> -->
      <!-- <template slot="footer">
        <div style="margin-bottom: 7rem !important;">
          <img class="img-fluid" src="img/brand/A2B_Logo2.png">
        </div>
      </template> -->

    </sidebar-menu>

  </div>

</template>
<script>
import modal from "@/components/Modal";
  export default {
    name: "DashboardNavbar",
    components: {
      modal
    },
    props: {
      menu: Array,
      sideBarTitle: String
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
        collapsed: false,
        // selectedTheme: 'white-theme',
        selectedTheme: '',
        openModal: false,
        selectedLine: "0",
        selectedPortfolio: "",
        currentSelectedProject: "",
        currentSelectedSubCategory: ""
      };
    },
    computed: {
      currentSelectedCategory: {
        get() {
          return this.$store.state.sideBarStore.currentSelectedCategory
        }
      }
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      onItemClick(event, item) {
        console.log(item);
        event.preventDefault();
        const current = this
        var categories =  [];
        var subCategories =  [];
        current.$store.state.sideBarStore.categories.forEach((categoryItem, categoryIndex) => {
          // console.log(categoryItem);
          categories.push(categoryItem.title)
          current.$store.state.sideBarStore.subCategories[categoryItem.code].forEach((subCategoryItem, subCategoryIndex) => {
            subCategories.push(subCategoryItem.title)
          });
        });

        var categorySelected = current.$store.state.sideBarStore.currentSelectedCategory
        // console.log(categories);
        // console.log(item.title);
        // console.log(item);
        // console.log(categories.includes(item.title));
        var tabList = document.getElementsByClassName("tabList")[0].getElementsByTagName('a')
        // console.log(tabList.item(0));
        // console.log("tablist clicked");
        if (tabList.item(0)) {
          tabList.item(0).click()
        }
        if(categories.includes(item.title)){
          // console.log(item.title);
          console.log("includes Item Title");
          current.$store.state.sideBarStore.categories.forEach((categoryItem, categoryIndex) => {
            if(item.title == categoryItem.title){
              categorySelected = categoryItem
              current.$store.commit("sideBarStore/setCurrentSelectedCategory",categoryItem)
              // for main category with tabs
              // current.$store.commit("sideBarStore/setActiveTabFlags", categoryItem.tabs[0].code+"Section")
              // current.$store.commit("sideBarStore/setCurrentSelectedTab", categoryItem)
              // current.$store.commit("sideBarStore/setActiveSidebarElement", item.title)

              // for selecting the first subcategory in the main category
              // console.log(categoryItem.sub);
              // console.log("Main Category Clicked");
              if(categoryItem.sub) {
                current.$store.commit("sideBarStore/setActiveTabFlags", current.$store.state.sideBarStore.subCategories[categorySelected.code][0].tabs[0].code+"Section")
                current.$store.commit("sideBarStore/setCurrentSelectedTab", current.$store.state.sideBarStore.subCategories[categorySelected.code][0])
                current.$store.commit("sideBarStore/setActiveSidebarElement", current.$store.state.sideBarStore.subCategories[categorySelected.code][0].title)
              }
              else {
                current.$store.commit("sideBarStore/setActiveTabFlags", categoryItem.tabs[0].code+"Section")
                current.$store.commit("sideBarStore/setCurrentSelectedTab", categoryItem)
                current.$store.commit("sideBarStore/setActiveSidebarElement", item.title)
              }

            }
          })

        }
        else {
          if(subCategories.includes(item.title)){
            // console.log(item.title);
            // console.log(categoryItem.sub);
            categorySelected.code = item.categoryCode
            var currentTabs =  current.$store.state.sideBarStore.subCategories[categorySelected.code].filter(function(obj) {
              return obj.title == item.title;
            });
            // console.log("Sub Category Clicked");
            // console.log("Not Category");
            current.$store.commit("sideBarStore/setCurrentSelectedSubCategory",current.$store.state.sideBarStore.subCategories[categorySelected.code])
            current.$store.commit("sideBarStore/setCurrentSelectedTab", currentTabs[0])
            current.$store.commit("sideBarStore/setActiveSidebarElement", item.title)
            current.$store.commit("sideBarStore/setActiveTabFlags", currentTabs[0].tabs[0].code+"Section")
          }
        }


      },
      openModalClicked: function() {
        this.openModal = true;
      },
      closeModalClicked: function() {
        this.openModal = false;
      },
    },
    mounted() {
      var firstElement = document.getElementsByClassName("vsm--link vsm--link_level-1 parentElementStyle")[0]
      // console.log("Overview clicked");
      firstElement.click()
    }
  };
</script>
<style>
.main-content {
    position: fixed !important;
    margin-left: 0px !important;
    width: 94.5%;
    width: -moz-available;          /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
    width: fill-available
}
.v-sidebar-menu {
    position: fixed !important;
    top: inherit !important;
    left: inherit !important;
    height: 100% !important;
}
.text-active-color span{
  /* color: #E66200 !important; */
  color: #e56511 !important;
  font-weight: bold!important;
  font-size: 20px;
  /* border: 1px solid #fff !important; */
}
</style>
